export const REQUIRED_FIELD_VALIDATION_MESSAGE = {
  message: 'Обязательное поле',
};

export const SMS_CODE_LENGTH = 6;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export const WAITING_TIME_AFTER_LOGIN = 1000;

export const INVITE_PATHNAME = '/auth/invite';
